var _tspan, _tspan2, _tspan3, _tspan4, _tspan5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHchsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.013118028640747, 0, 0, 1.013118028640747, -3.043390989303589, -178.2969207763672)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 147)",
      paintOrder: "stroke",
      stroke: "rgb(0, 56, 147)"
    },
    x: 202,
    y: 214.944,
    width: 15,
    height: 66,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 147)",
      paintOrder: "stroke",
      stroke: "rgb(0, 56, 147)"
    },
    x: 481.53,
    y: 215.08,
    width: 15,
    height: 66,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 147)",
      paintOrder: "stroke",
      stroke: "rgb(0, 56, 147)"
    },
    x: 3.004,
    y: 215.15,
    width: 15,
    height: 66,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 60, 149)",
      fontFamily: "Arial, sans-serif",
      fontSize: "7.2px",
      whiteSpace: "pre"
    },
    transform: "matrix(4.980847, 0, 0, 4.565359, -970.752686, -789.530029)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 242.777,
    y: 224.965
  }, "Hamburg City")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 242.77699279785156,
    dy: "1.3em"
  }, "\u200B")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", null, "Health  Study")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 242.77699279785156,
    dy: "1.3em"
  }, "\u200B")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 242.77699279785156,
    dy: "1.3em"
  }, "\u200B")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(225, 0, 72)",
      stroke: "rgb(225, 0, 72)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.913547, 0.406734, -0.406734, 0.913547, 104.15554, -27.515139)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 122, 205)",
      stroke: "rgb(0, 122, 205)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.998027, 0.062788, -0.062788, 0.998027, 11.509869, -7.548846)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 149)",
      stroke: "rgb(0, 56, 149)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.981627, -0.190811, 0.190811, 0.981627, -76.114807, 29.232239)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 149)",
      stroke: "rgb(0, 56, 149)"
    },
    x: 125.525,
    y: 186.23,
    width: 5.188,
    height: 137.211,
    rx: 1,
    ry: 1,
    transform: "matrix(0.961261, -0.27564, 0.27564, 0.961261, -74.599902, 38.298868)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 149)",
      stroke: "rgb(0, 56, 149)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.355104, -0.934827, 0.934827, 0.355104, -172.668261, 286.386341)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 122, 205)",
      stroke: "rgb(0, 122, 205)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.53435, -0.845263, 0.845263, 0.53435, -163.154236, 207.692117)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(225, 0, 72)",
      stroke: "rgb(225, 0, 72)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.185668, 0.982613, -0.982613, 0.185668, 331.723431, 68.827247)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(225, 0, 72)",
      stroke: "rgb(225, 0, 72)"
    },
    x: 125.525,
    y: 186.702,
    width: 5.188,
    height: 137.559,
    rx: 1,
    ry: 1,
    transform: "matrix(0.627962, -0.778244, 0.778244, 0.627962, -173.089806, 192.000903)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 122, 205)",
      stroke: "rgb(0, 122, 205)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.953455, 0.301535, -0.301535, 0.953455, 51.594761, -31.7939)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 149)",
      stroke: "rgb(0, 56, 149)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.612909, 0.790154, -0.790154, 0.612909, 230.094166, -3.89692)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 56, 149)",
      stroke: "rgb(0, 56, 149)"
    },
    x: 125.525,
    y: 183.608,
    width: 5.188,
    height: 135.279,
    rx: 1,
    ry: 1,
    transform: "matrix(0.151263, 0.988494, -0.988494, 0.151263, 340.269506, 92.724462)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHchsLogo);
export default __webpack_public_path__ + "static/media/hchs_logo.9adc6aef4bde239e9466a83c1a679710.svg";
export { ForwardRef as ReactComponent };